import React from 'react';
import PropTypes from 'prop-types';
import {
  Price,
  PriceBeforeDiscount,
  StyledAmountInfo,
  SaveText,
} from './styles';

export const Pricing = ({
  discountedPrice,
  price,
  period,
  message,
  savePercent,
}) => {
  return (
    <>
      {discountedPrice !== 'FREE' ? (
        <StyledAmountInfo>
          <PriceBeforeDiscount>{price}</PriceBeforeDiscount>
          <Price>
            {discountedPrice}
            {discountedPrice && period && `/${period}`}
            {message}
            {savePercent && <SaveText>{savePercent}</SaveText>}
          </Price>
        </StyledAmountInfo>
      ) : (
        <StyledAmountInfo>
          <Price>{discountedPrice}</Price>
        </StyledAmountInfo>
      )}
    </>
  );
};

Pricing.propTypes = {
  price: PropTypes.string,
  discountedPrice: PropTypes.string,
  period: PropTypes.string,
  message: PropTypes.string,
  savePercent: PropTypes.string,
};
